export default __webpack_public_path__ + "static/media/bigguy.c809fc90.webp";